import { createStore } from 'redux';
import { reducers1 } from '../reducer/reducers';
import { combineReducers } from 'redux';

const routeReducer = combineReducers({
    cart: reducers1,
})
const Store = createStore(routeReducer);
export default Store;